
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'

@Component({
    inheritAttrs: false,
    name: 'log-psi',
    components: { LogTemplate },
})
export default class LogPsi extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    get customString() {
        switch (this.log.logEventName) {
            case 'psiIsBklrPsiUpdated':
            case 'psiIsBklrAccessPsiUpdated':
            case 'psiIsArchivedUpdated':
            case 'psiSuggestToAllUsersUpdated':
            case 'psiRequireForAppCheckInUpdated':
            case 'psiUseCoursesUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`

            case 'psiActiveRevisionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`

            case 'psiCompletedByUser':
                this.bklrGrantAccessUrl = this.log.payload.bklrGrantAccessUrl
                return `${this.log.logEventName}_${
                    this.log.payload['bklrGrantAccessUrl']
                        ? 'notNull(bklrGrantAccessUrl)'
                        : 'isNull(bklrGrantAccessUrl)'
                }`

            default:
                return this.log.logEventName
        }
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null
    bklrGrantAccessUrl: string | null = null
}
